<template>
  <div>
    <search-form ref="searchForm" @search="handleSearch">
      <el-button type="primary" class="right" :loading="loading" @click="handleSearch">
        {{ $t('common.search') }}
      </el-button>
    </search-form>

    <el-card>
      <el-select
        class="form-field"
        v-model="cycle"
        placeholder="请选择周期"
        @change="handleSearch"
      >
        <el-option
          v-for="[id] of cycleMap"
          :key="id"
          :label="$t(`data.perform.cycleMap[${id}]`)"
          :value="id"
        >
        </el-option>
      </el-select>

      <sort-group v-model="sort" @change="handleSearch">
        <sort-item :label="$t('data.apply.hottest')" value="hot"></sort-item>
        <sort-item :label="$t('data.apply.newest')" value="new"></sort-item>
        <template v-if="cycle !== -9999">
          <sort-item :label="$t('data.apply.increase')" value="play_asc"></sort-item>
          <sort-item :label="$t('data.apply.decrease')" value="play_desc"></sort-item>
        </template>
      </sort-group>

      <br>
      <br>

      <el-table
        :data="tableData"
        v-loading="loading"
        row-key="trackId"
      >
        <el-table-column
          :label="$t('data.apply.no')"
          prop="index"
          width="60"
        ></el-table-column>
        <el-table-column
          :label="$t('data.apply.interval')"
          prop="interval"
          width="110"
        ></el-table-column>
        <el-table-column
          :label="$t('data.apply.trackInfo')"
          v-slot="{ row }"
          width="200"
        >
          <div class="track-info">
            <div class="track-info-photo" :style="{backgroundImage: `url(${row.albumPhoto})`}" />
            <div class="track-info-message">
              <p><auto-tip-text :content="row.trackName"></auto-tip-text></p>
              <p><auto-tip-text :content="`${ row.singerName } - ${ row.album ? row.album.albumName : '无' }`"></auto-tip-text></p>
            </div>
          </div>
        </el-table-column>
        <el-table-column :label="$t('data.apply.version')" prop="srcVersion"></el-table-column>
        <el-table-column :label="$t('data.apply.language')" v-slot="{ row }">
          {{ languageMap[row.language] }}
        </el-table-column>
        <!-- <el-table-column label="厂牌" prop="companyName" width="160"></el-table-column> -->
        <el-table-column :label="$t('common.publicTime')" v-slot="{ row }">
          {{ row.publicTime }}
        </el-table-column>

        <el-table-column
          :label="tableLabels.play"
          prop="playCnt"
          width="70"
          v-slot="{ row }"
        >
          <template v-if="row.isIndex">
            {{ row.playCnt }}
          </template>
          <template v-else>
            {{ row.playCnt | displayCount }}
          </template>
        </el-table-column>
        <el-table-column
          :label="tableLabels.download"
          prop="downloadCnt"
          width="70"
          v-slot="{ row }"
        >
          <template v-if="row.isIndex">
            {{ row.downloadCnt }}
          </template>
          <template v-else>
            {{ row.downloadCnt | displayCount }}
          </template>
        </el-table-column>
        <el-table-column
          :label="tableLabels.fav"
          prop="downloadCnt"
          width="70"
          v-slot="{ row }"
        >
          <template v-if="row.isIndex">
            {{ row.favCnt }}
          </template>
          <template v-else>
            {{ row.favCnt | displayCount }}
          </template>
        </el-table-column>

        <!-- <el-table-column>
          <template #header>
            收藏量/指标数
            <el-tooltip effect="dark" content="指数 = 指标数据 * ( 1 + lg ( sqrt ( 指标数据 ) + 1 ) / 20 ) / 455" placement="top-start">
              <i class="el-icon-question"/>
            </el-tooltip>
          </template>
          <template v-slot="{ row }">
            {{ row.commentCntRate | toFixed(4) }}
          </template>
        </el-table-column> -->

        <el-table-column label="评论数">
          <template #header>
            {{ $t('data.apply.remarks') }}
            <el-tooltip effect="dark" content="因客户端可以进行评论管理，评论数统计与客户端可能存在差异" placement="top-start">
              <i class="el-icon-question" />
            </el-tooltip>
          </template>
          <template v-slot="{ row }">
            {{ row.commentCnt | displayCount }}
          </template>
        </el-table-column>

        <el-table-column label="评论日增长指数">
          <template #header>
            {{ $t('data.apply.remarksIncrease') }}
            <el-tooltip effect="dark" content="评论日增长数 =（ 今日评论新增-昨日评论新增 ）/ 昨日评论新增" placement="top-start">
              <i class="el-icon-question" />
            </el-tooltip>
          </template>
          <template v-slot="{ row }">
            {{ row.commentCntRate | toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('data.apply.qqRank')" prop="qqRank"></el-table-column>
        <el-table-column :label="$t('data.apply.kugouRank')" prop="kgRank"></el-table-column>

        <el-table-column
          :label="$t('data.apply.trend')"
          fixed="right"
          width="60"
          v-slot="{row}"
          align="center"
        >
          <el-popover
            placement="bottom-end"
            :ref="`popover-${row.trackId}`"
            width="740"
            trigger="click"
            @hide="row.showChart = false"
          >
            <trend-chart
              v-if="row.showChart"
              :platform="$refs.searchForm.form.platform"
              :cycle="cycle"
              :is-index="row.isIndex"
              :track-id="row.trackId"
            ></trend-chart>
            <i slot="reference" class="el-icon-arrow-down arrow-down" :class="{active: row.showChart}" @click="handleOpen(row)" />
          </el-popover>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSearch"
        @current-change="fetchData"
        :current-page.sync="pagination.current"
        :page-size.sync="pagination.size"
        :page-sizes="[10, 50, 100, 1000, 2000]"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import SearchForm from './components/SearchForm.vue'
import SortGroup from './components/SortGroup.vue'
import SortItem from './components/SortItem.vue'
import TrendChart from './components/TrendChart.vue'
import dataService from '@/api/data'
import { cycleMap, languageMap } from '../mixin'
import AutoTipText from '@/components/AutoTipText/index.vue'
import dayjs from 'dayjs'

export default {
  name: 'Apply',

  components: {
    AutoTipText,
    SearchForm,
    SortItem,
    SortGroup,
    TrendChart
  },

  data() {
    return {
      isIndexCount: 0,
      cycle: -7,
      loading: false,
      sort: 'hot',

      time: '',

      cycleMap,
      languageMap,

      tableData: [],

      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
    }
  },

  computed: {
    tableLabels() {
      // 全部非优选
      if (this.isIndexCount === 0) {
        return {
          play: this.$t('data.apply.streams'),
          download: this.$t('data.apply.downloads'),
          fav: this.$t('data.apply.favorites'),
        }

      // 全部优选
      } else if (this.isIndexCount === this.tableData.length) {
        return {
          play: this.$t('data.apply.streamsIndex'),
          download: this.$t('data.apply.downloadsIndex'),
          fav: this.$t('data.apply.favoritesIndex'),
        }
      }

      // 部分优选
      return {
        play: this.$t('data.apply.streamsAndIndex'),
        download: this.$t('data.apply.downloadsAndIndex'),
        fav: this.$t('data.apply.favoritesAndIndex'),
      }
    }
  },

  methods: {
    handleOpen(row) {
      row.showChart = !row.showChart
    },
    handleSearch() {
      if (this.cycle === -9999 && this.sort !== 'new') {
        this.sort = 'hot'
      }
      this.pagination.current = 1
      this.fetchData()
    },
    async fetchData() {
      const { pagination } = this
      const searchForm = this.$refs.searchForm.form
      searchForm.publicTime = searchForm.publicTime ? searchForm.publicTime : ''
      const searchData = {
        ...searchForm,
        page: pagination.current - 1,
        num: pagination.size,
        cycle: this.cycle,
        sort: this.sort
      }
      this.loading = true
      this.tableData.forEach(item => {
        this.$refs[`popover-${item.trackId}`] && this.$refs[`popover-${item.trackId}`].doClose()
      })
      try {
        const res = await dataService.queryWordData(searchData)
        let isIndexCount = 0
        this.tableData = res.list.map((val, index) => {
          let albumPhoto = require('@/assets/default_img.png')
          const [from, to] = val.interval.split('-')

          if (val.album &&
            val.album.albumPhotoList &&
            Array.isArray(val.album.albumPhotoList) &&
            val.album.albumPhotoList[0] &&
            typeof val.album.albumPhotoList[0].photoUrl === 'string'
          ) {
            albumPhoto = val.album.albumPhotoList[0].photoUrl
          }
          isIndexCount += +val.isIndex

          val.interval = `${dayjs(from).format('YYYY-MM-DD')} ${this.$t('data.apply.to')} ${dayjs(to).format('YYYY-MM-DD')}`

          return {
            albumPhoto,
            index: (pagination.current - 1) * pagination.size + index + 1,
            ...val,
            showChart: false
          }
        })

        this.isIndexCount = isIndexCount

        this.pagination.total = res.total
      } catch (e) {
        this.$message.error('查询异常：' + e.message)
      } finally {
        this.loading = false
      }
    }
  },
}
</script>

<style lang="scss" scoped>
$primary-color: #1672fa;
$default-color: #bebebe;

.sort-item {
  line-height: 18px;
  display: inline-flex;
  font-size: 14px;
  margin-left: 40px;
  color: $default-color;
  cursor: pointer;
  &:before {
    content: "";
    display: inline-block;
    margin: 3px 4px 0 0;
    border-radius: 5px;
    width: 10px;
    height: 10px;
    background-color: $default-color;
  }
  &:hover {
    color: $primary-color;
  }
}

.triangle-top {
  display: block;
  width: 0px;
  height: 0px;
  border: 4px solid transparent;
  border-bottom: 4px solid $default-color;
  margin-bottom: 2px;
  margin-top: -3px;
}

.triangles {
  margin: 2px 0 0 10px;
  display: inline-block;
  height: 12px;
  overflow: hidden;
}

.triangle-bottom {
  display: block;
  width: 0px;
  height: 0px;
  border: 4px solid transparent;
  border-top: 4px solid $default-color;
}

.arrow-down {
  transition: transform 0.3s ease-in-out;
  &.active {
    transform: rotate(180deg);
  }
}

.track-info {
  display: flex;
  .track-info-photo {
    width: 42px;
    height: 42px;
    margin-right: 10px;
    background-size: cover;
    background-position: center;
  }
  .track-info-message {
    width: 110px;
  }
}
</style>
